import React, { useEffect, useState } from "react";
import { Table, Input } from "antd";
import { Link, useNavigate } from "react-router-dom";
import AddEmployee from "./AddEmployee";
import { deleteEmployee } from "./store/employeeSlice";
import { useDispatch } from "react-redux";
import DeleteModal from "../../../components/modelpopup/DeleteModal";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import EditEmployeeData from "./EditEmployeeData";
import api from "../../../api";
import { fetchEmployee } from "./store/employeeSlice";

const EmployeeDataTable = ({ data, loading }) => {
  const [selectedEmployeeId, setSelectedEmployeeId] = useState(null);
  const [openDropdownId, setOpenDropdownId] = useState(null);
  const [empStatus, setEmpStatus] = useState({}); // State to track status per employee
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [isEditModalOpen, setEditModalOpen] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { successMessage, error } = useSelector((state) => state.employeeData);
  const userType = localStorage.getItem("type");

  const handleGenerateSlip = async (record) => {
    try {
      localStorage.setItem("employee_code",record.employee_code);
      navigate(`/salary-view/${record.id}`);
    } catch (error) {
      console.error("Error fetching payroll data:", error);
      toast.error("Failed to generate payslip. Please try again.");
    }
  };

  const toggleDropdown = (employeeId) => {
    // Toggle dropdown for the specific employee
    setOpenDropdownId(openDropdownId === employeeId ? null : employeeId);
  };

  const handleStatusChange = async (employeeId, status) => {
    try {
      const response = await api.post("change-employee-status", {
        employee_id: employeeId,
        status: status,
      });

      if (response.status === 200) {
        // Update status in the state for the specific employee
        setEmpStatus((prevStatus) => ({
          ...prevStatus,
          [employeeId]: status, // Update the status for the specific employee
        }));
        toast.success(`Status updated to ${status}`);
      } else {
        toast.error("Failed to update status. Please try again.");
      }
    } catch (error) {
      console.error("Error updating status:", error);
      toast.error("Failed to update status. Please try again.");
    }
  };

  useEffect(() => {
    if (successMessage) {
      toast.success(successMessage);
    }
    if (error) {
      toast.error(error);
    }
  }, [successMessage, error]);

  const handleDelete = (employeeId) => {
    dispatch(deleteEmployee(employeeId));
    setDeleteModalOpen(false);
  };

  const columns = [
    {
      title: "First Name",
      dataIndex: "first_name",
    },
    {
      title: "Last Name",
      dataIndex: "last_name",
    },
    {
      title: "Email",
      dataIndex: "email",
    },
    {
      title: "Employee Code",
      dataIndex: "employee_code",
    },
    {
      title: "Phone",
      dataIndex: "phone",
    },
    {
      title: "Joining Date",
      dataIndex: "date_of_joining",
    },
    {
      title: "Status",
      render: (text, record) => (
        <div className="dropdown">
          <button
            onClick={() => toggleDropdown(record.id)} // Use specific ID to toggle
            className="btn btn-white dropdown-toggle"
            aria-expanded={openDropdownId === record.id ? "true" : "false"}
          >
            {empStatus[record.id] || record.status}
          </button>

          {openDropdownId === record.id && (
            <ul
              className="dropdown-menu dropdown-menu-end p-3"
              style={{ display: "block" }}
            >
              <li>
                <button
                  className="dropdown-item rounded-1"
                  onClick={() => {
                    handleStatusChange(record.id, "Working");
                    setOpenDropdownId(null); // Close the dropdown
                  }}
                >
                  Working
                </button>
              </li>
              <li>
                <button
                  className="dropdown-item rounded-1"
                  onClick={() => {
                    handleStatusChange(record.id, "Not Working");
                    setOpenDropdownId(null); // Close the dropdown
                  }}
                >
                  Not Working
                </button>
              </li>
            </ul>
          )}
        </div>
      ),
    },
    {
      title: "Action",
      render: (text, record) => (
        <div className="d-flex align-items-center">
          {userType !== "Admin" && (
            <OverlayTrigger
              placement="top"
              overlay={
                <Tooltip id={`tooltip-delete-${record.id}`}>Delete</Tooltip>
              }
            >
              <Link
                className="btn btn-icon btn-danger btn-sm me-2"
                to="#"
                onClick={() => {
                  setSelectedEmployeeId(record.id);
                  setDeleteModalOpen(true);
                }}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "36px",
                  height: "36px",
                  borderRadius: "50%",
                  backgroundColor: "#e74c3c",
                  color: "#fff",
                  fontSize: "18px",
                  border: "none",
                }}
              >
                <i className="fa fa-trash" />
              </Link>
            </OverlayTrigger>
          )}

          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id={`tooltip-edit-${record.id}`}>Edit</Tooltip>}
          >
            <Link
              to="#"
              className="btn btn-icon btn-primary btn-sm me-2"
              onClick={() => {
                setSelectedEmployeeId(record.id);
                setEditModalOpen(true);
              }}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "36px",
                height: "36px",
                borderRadius: "50%",
                backgroundColor: "#3498db",
                color: "#fff",
                fontSize: "18px",
                border: "none",
              }}
            >
              <i className="fa fa-pencil" />
            </Link>
          </OverlayTrigger>

          <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip id={`tooltip-slip-${record.id}`}>Generate Slip</Tooltip>
            }
          >
            <button
              className="btn btn-icon btn-primary btn-sm"
              onClick={() => handleGenerateSlip(record)}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "36px",
                height: "36px",
                borderRadius: "50%",
                backgroundColor: "#3498db",
                color: "#fff",
                fontSize: "18px",
                border: "none",
              }}
            >
              <i className="fa fa-file" />
            </button>
          </OverlayTrigger>
        </div>
      ),
    },
  ];

  return (
    <div className="row">
      <div className="col-md-12">
        <div className="d-flex justify-content-end">
          <Input
            placeholder="Search Name, Mobile Number, Employee Code"
            style={{ width: 200 }}
            onKeyUp={(e) => {
              dispatch(fetchEmployee(e.target.value));
            }}
          />
        </div>
        <div className="table-responsive">
           
          <Table
            columns={columns}
            dataSource={data}
            loading={loading}
            rowKey="id"
            pagination={{
              pageSize: 10, // Keep a fixed number of items per page
              showSizeChanger: false, // Hide the "per page" dropdown
            }}
          />
          {isModalOpen && (
            <AddEmployee
              show={isModalOpen}
              onClose={() => setIsModalOpen(false)}
              userId={selectedEmployeeId}
            />
          )}
          {isEditModalOpen && (
            <EditEmployeeData
              show={isEditModalOpen}
              onClose={() => setEditModalOpen(false)}
              employeeId={selectedEmployeeId}
            />
          )}
          {deleteModalOpen && (
            <DeleteModal
              onConfirm={() => handleDelete(selectedEmployeeId)}
              onCancel={() => setDeleteModalOpen(false)}
              Name="Employee"
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default EmployeeDataTable;
